import { Breadcrumbs, Divider, Paper, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css";
//import AppBarDashboard from "../../components/AppBar/AppBar.Dashboard";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
//import { Container } from "../../components/Styles/Container";
import { Theme } from "../../config/aws-exports";
import { HeadingPrimary } from "../../components/Styles/Heading";
import { Wrapper } from "./Notifications.styles";
import { Box } from "@mui/system";
import DeleteIcon from "@mui/icons-material/Delete";
// import useFetch from "../../Hooks/useFetch";
import config from "../../config/aws-exports";
// import gif from '../../assets/giphy.gif';

import { useSelector } from "react-redux";
import { authData } from "../../redux/auth/authSlice";
import { useNavigate, Link } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";
import { API } from "@aws-amplify/api";
import { useQuery } from "react-query";
import emptysearch from "../../assets/Nothing here yet.gif";

const Notifications = () => {
  const userDetails = useSelector(authData);
  const navigate = useNavigate();
  const { data, error, refetch } = useQuery("notifications", async () => {
    try {
      // const id = await parseInt(window.localStorage.getItem("ur_id"));
      const res = await API.post(
        config.aws_cloud_logic_custom_name,
        "/getNotifications",
        {
          body: {
            oid: config.aws_org_id,
            eid: userDetails.username,
            tenant: userDetails?.uData.oid,
            ur_id: userDetails?.uData?.ur_id,
            schema: config.schema,
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            // Authorization: jwttoken,
          },
        },
      );

      return res;
    } catch (err) {
      console.error(err.message);
    }
  });

  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (data) {
      console.log("notifications==", data);
      const { notifications } = data;
      const decNotification = notifications.sort((a, b) => {
        const aTime = parseInt(a.time);
        const bTime = parseInt(b.time);
        console.log(aTime);
        console.log(bTime);
        return bTime - aTime;
      });
      console.log(decNotification);
      setNotifications(decNotification);
    }
  }, [data]);

  async function notificationStatus(msg, type) {
    if (type === "message") {
      if (msg.type === 1) {
        navigate(`/course?id=${msg.tid}`);
      } else if (msg.type === 2) {
        window.open(msg.link, "_blank");
      } else {
        Swal.fire({
          html: `
          <div class='notify'>
          <div class='max-w'>
          <h5 class='md'>${msg.title.substring(0, 80)}${
            msg.title.length > 80 ? "..." : ""
          }</h5>
          </div>
          
  <div class="ql-editor">
        ${msg.msg}
      </div>

          <a href='${msg.link}' target='_black'>${msg.link ?? ""}</a>
          </div>
        
<style>
      .max-w { max-width: 450px; }
      .notify { display: flex; flex-direction: column; gap: 1rem; }
      .md { font-size: 22px; }

      
.swal2-title {
        margin-top: 0 !important;
      }
      .swal2-html-container {
        margin-top: 0 !important;
        padding-top: 0 !important;
      }


      /* Quill alignment support */
      .ql-align-left { text-align: left; }
      .ql-align-center { text-align: center; }
      .ql-align-right { text-align: right; }
      .ql-align-justify { text-align: justify; }

      /* Optional Quill styling */
      .ql-editor {
        line-height: 1.6;
        font-size: 16px;
        margin-top:-90px;
      }

      .ql-editor ul,
      .ql-editor ol {
        padding-left: 20px;
      }

      .ql-editor p {
        margin: 8px 0;
      }

   
      .ql-editor img,
  .ql-editor picture {
    display: inline;       
   
  }

    </style>

          `,
          showConfirmButton: true,
          confirmButtonColor: Theme.color.primary,
          confirmButtonText: "Ok",
        });
      }
      setNotifications((prev) => {
        return prev.map((notification) =>
          msg.nt_id === notification.nt_id
            ? { ...notification, read: 1 }
            : { ...notification },
        );
      });
    } else {
      setNotifications((prev) => {
        return prev.filter((notification) => msg.nt_id !== notification.nt_id);
      });
    }

    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        eid: userDetails.username,
        tenant: userDetails.tenant,
        nt_id: msg.nt_id,
        ur_id: userDetails?.uData?.ur_id,
        time: msg.time,
        type: type,
        schema: config.schema,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    if (type === "delete") bodyParam.body.type = "delete";

    console.log(JSON.stringify(bodyParam.body, null, 2));
    try {
      await API.post(
        config.aws_cloud_logic_custom_name,
        "/postNotificationStatusWeb",
        bodyParam,
      );

      refetch();
    } catch (err) {
      console.error(err);
    }
  }

  const breadcrumbs = [
    <Link to="/dashboard">Dashboard</Link>,
    <Typography key="3" color={Theme.color.text}>
      Notifications
    </Typography>,
  ];
  if (error) return error.message;

  return (
    <Wrapper>
      <Stack spacing={2} margin={{ xs: 1, sm: 2, md: 3 }}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="breadcrumb"
          sx={{ color: Theme.color.black }}
        >
          {breadcrumbs}
        </Breadcrumbs>
        {/* <Stack
          direction="row"
          //alignItems="center"
          justifyContent="space-between"
        > */}
        <HeadingPrimary>Notifications</HeadingPrimary>
        {/* </Stack> */}

        <Paper sx={{ boxShadow: Theme.boxShadow, mb: 4 }}>
          {notifications?.map((notification) => (
            <Box key={notification.nt_id} sx={{ p: 2 }}>
              <Stack direction="row" justifyContent="space-between">
                <Stack
                  spacing={1}
                  sx={{ flex: 1, cursor: "pointer" }}
                  onClick={() => notificationStatus(notification, "message")}
                >
                  <Stack direction="row" spacing={1} flexWrap="wrap">
                    {notification.read === 0 && (
                      <Box
                        sx={{
                          backgroundColor: Theme.color.primary,
                          color: "#fff",
                          px: 1,
                          py: 0.3,
                          borderRadius: 1,
                          fontSize: "12px",
                        }}
                      >
                        New
                      </Box>
                    )}

                    <Box component="h4" sx={{ m: 0 }}>
                      {notification.title}
                    </Box>

                    <Typography variant="caption" color="text.secondary">
                      {notification.time &&
                        moment(parseInt(notification.time)).format(
                          "DD MMM YYYY",
                        )}
                    </Typography>
                  </Stack>

                  <Box
                    className="ql-editor"
                    sx={{
                      width: "100%",
                      fontSize: { xs: "14px", sm: "16px" },
                      wordBreak: "break-word",

                      "& img": {
                        maxWidth: "100%",
                        height: "auto",
                        display: "block",
                      },

                      "& .ql-align-center img": {
                        marginLeft: "auto",
                        marginRight: "auto",
                      },

                      "& .ql-align-right img": {
                        marginLeft: "auto",
                      },

                      "& .ql-align-left img": {
                        marginRight: "auto",
                      },
                    }}
                    dangerouslySetInnerHTML={{ __html: notification.msg }}
                  />
                </Stack>

                <Box sx={{ ml: 1 }}>
                  <DeleteIcon
                    sx={{ cursor: "pointer" }}
                    onClick={() => notificationStatus(notification, "delete")}
                  />
                </Box>
              </Stack>

              <Divider sx={{ mt: 2 }} />
            </Box>
          ))}
        </Paper>

        {data?.notifications.length === 0 && (
          <div
            style={{
              height: "60vh",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <img src={emptysearch} alt="emptysearch" />
          </div>
        )}
      </Stack>
    </Wrapper>
  );
};

export default Notifications;
